// Gerado por tools/assets (`pnpm --filter @eldrun/assets sounds`). Não edite à mão.
// Fonte: tools/assets/src/sounds/manifest.ts; relatório em docs/assets/sound-build-report.json.
import type { BedId } from "../audio/ambience-model.ts";
import type { TrackId } from "../audio/audio-model.ts";
import type { SoundId } from "../audio/recipes.ts";

/** Taxa das amostras: o banco decodifica nela e corta cada uma em `frames`. */
export const SAMPLE_RATE = 48000;

export interface SampleFile {
  /** Opus em WebM (principal) e MP3 (reserva) em public/, com o hash do conteúdo no nome. */
  readonly webm: string;
  readonly mp3: string;
  /** Amostras a 48000 Hz; o que o decodificador entregar a mais é atraso ou enchimento. */
  readonly frames: number;
  /** Amostras até chegar 2 % da energia: o banco tira do começo o atraso que sobrou comparando com ele. */
  readonly onset: number;
  /** Loops (F46): o trecho que repete, em segundos; antes e depois dele, o enchimento circular. */
  readonly loopStart?: number;
  readonly loopEnd?: number;
}

/** Variações de cada conjunto. */
export const SAMPLE_SETS = {
  "passo-terra": [
    { webm: "/sons/passo-terra-1.14206398.webm", mp3: "/sons/passo-terra-1.23418f6f.mp3", frames: 24029, onset: 662 },
    { webm: "/sons/passo-terra-2.4e6bf168.webm", mp3: "/sons/passo-terra-2.501e1d85.mp3", frames: 23637, onset: 267 },
    { webm: "/sons/passo-terra-3.c2dd64a6.webm", mp3: "/sons/passo-terra-3.729f7f4a.mp3", frames: 23796, onset: 503 },
    { webm: "/sons/passo-terra-4.9e106c95.webm", mp3: "/sons/passo-terra-4.12d51419.mp3", frames: 23885, onset: 343 },
  ],
  "passo-pedra": [
    { webm: "/sons/passo-pedra-1.a210dcfe.webm", mp3: "/sons/passo-pedra-1.d41f8502.mp3", frames: 23045, onset: 188 },
    { webm: "/sons/passo-pedra-2.bd2e2718.webm", mp3: "/sons/passo-pedra-2.b1ff4bd0.mp3", frames: 23483, onset: 173 },
    { webm: "/sons/passo-pedra-3.7c66456a.webm", mp3: "/sons/passo-pedra-3.f316d70b.mp3", frames: 23247, onset: 233 },
    { webm: "/sons/passo-pedra-4.afce35ce.webm", mp3: "/sons/passo-pedra-4.0f21909a.mp3", frames: 22942, onset: 185 },
  ],
  "passo-madeira": [
    { webm: "/sons/passo-madeira-1.6c4149d2.webm", mp3: "/sons/passo-madeira-1.32c16fa4.mp3", frames: 23407, onset: 137 },
    { webm: "/sons/passo-madeira-2.e999d48a.webm", mp3: "/sons/passo-madeira-2.e1849750.mp3", frames: 22879, onset: 141 },
    { webm: "/sons/passo-madeira-3.608adf63.webm", mp3: "/sons/passo-madeira-3.0b60748b.mp3", frames: 22311, onset: 140 },
    { webm: "/sons/passo-madeira-4.411b66c1.webm", mp3: "/sons/passo-madeira-4.1a16f623.mp3", frames: 23085, onset: 131 },
  ],
  "passo-agua": [
    { webm: "/sons/passo-agua-1.d255e1a5.webm", mp3: "/sons/passo-agua-1.cdd74106.mp3", frames: 23755, onset: 226 },
    { webm: "/sons/passo-agua-2.e241d827.webm", mp3: "/sons/passo-agua-2.dd25685f.mp3", frames: 23789, onset: 833 },
    { webm: "/sons/passo-agua-3.45a065ea.webm", mp3: "/sons/passo-agua-3.8a9d0d69.mp3", frames: 23469, onset: 376 },
    { webm: "/sons/passo-agua-4.5e7a5f1f.webm", mp3: "/sons/passo-agua-4.1785076b.mp3", frames: 23017, onset: 666 },
  ],
  "machado-madeira": [
    { webm: "/sons/machado-madeira-1.d59e43aa.webm", mp3: "/sons/machado-madeira-1.285445b1.mp3", frames: 22982, onset: 6486 },
    { webm: "/sons/machado-madeira-2.9f00001b.webm", mp3: "/sons/machado-madeira-2.e64bf6ab.mp3", frames: 18328, onset: 858 },
    { webm: "/sons/machado-madeira-3.09d1316d.webm", mp3: "/sons/machado-madeira-3.d2e07a9b.mp3", frames: 24498, onset: 6564 },
    { webm: "/sons/machado-madeira-4.8d801029.webm", mp3: "/sons/machado-madeira-4.bfcd5228.mp3", frames: 13836, onset: 4051 },
  ],
  "picareta": [
    { webm: "/sons/picareta-1.83c86f24.webm", mp3: "/sons/picareta-1.41c24781.mp3", frames: 17544, onset: 697 },
    { webm: "/sons/picareta-2.fa7c33ab.webm", mp3: "/sons/picareta-2.a4bd052e.mp3", frames: 14267, onset: 250 },
    { webm: "/sons/picareta-3.2eab9b39.webm", mp3: "/sons/picareta-3.cea1cf52.mp3", frames: 13839, onset: 101 },
    { webm: "/sons/picareta-4.c938f98a.webm", mp3: "/sons/picareta-4.69002459.mp3", frames: 14236, onset: 99 },
  ],
  "golpe-ar": [
    { webm: "/sons/golpe-ar-1.060643ee.webm", mp3: "/sons/golpe-ar-1.f39a90c0.mp3", frames: 22318, onset: 5682 },
    { webm: "/sons/golpe-ar-2.37b99979.webm", mp3: "/sons/golpe-ar-2.793e6698.mp3", frames: 20625, onset: 6134 },
    { webm: "/sons/golpe-ar-3.c8670f2d.webm", mp3: "/sons/golpe-ar-3.1fd90c49.mp3", frames: 21883, onset: 5855 },
  ],
  "acerto": [
    { webm: "/sons/acerto-1.c0ae7fa5.webm", mp3: "/sons/acerto-1.38125669.mp3", frames: 21750, onset: 308 },
    { webm: "/sons/acerto-2.8b20f9f5.webm", mp3: "/sons/acerto-2.c1f6e728.mp3", frames: 24000, onset: 242 },
    { webm: "/sons/acerto-3.cd5c2abc.webm", mp3: "/sons/acerto-3.cc5369c9.mp3", frames: 21927, onset: 222 },
  ],
  "flecha-solta": [
    { webm: "/sons/flecha-solta-1.9b9e158a.webm", mp3: "/sons/flecha-solta-1.d5cf9b25.mp3", frames: 30000, onset: 1624 },
    { webm: "/sons/flecha-solta-2.87fe34c1.webm", mp3: "/sons/flecha-solta-2.9250c0ed.mp3", frames: 30000, onset: 6076 },
  ],
  "flecha-crava": [
    { webm: "/sons/flecha-crava-1.6bcb14fe.webm", mp3: "/sons/flecha-crava-1.6cb07ee2.mp3", frames: 32505, onset: 2035 },
    { webm: "/sons/flecha-crava-2.2319da3f.webm", mp3: "/sons/flecha-crava-2.f2b612d9.mp3", frames: 34757, onset: 7014 },
    { webm: "/sons/flecha-crava-3.b18a32b5.webm", mp3: "/sons/flecha-crava-3.5b76cea6.mp3", frames: 35947, onset: 6981 },
  ],
  "bau": [
    { webm: "/sons/bau-1.d6f2ed15.webm", mp3: "/sons/bau-1.1431ae39.mp3", frames: 52861, onset: 5310 },
    { webm: "/sons/bau-2.0ab547f9.webm", mp3: "/sons/bau-2.10911dfa.mp3", frames: 63002, onset: 2379 },
  ],
  "bau-fecha": [
    { webm: "/sons/bau-fecha-1.7a080a3d.webm", mp3: "/sons/bau-fecha-1.50f0e836.mp3", frames: 33714, onset: 3400 },
    { webm: "/sons/bau-fecha-2.ec9855ea.webm", mp3: "/sons/bau-fecha-2.16e42459.mp3", frames: 35675, onset: 3430 },
  ],
  "porta": [
    { webm: "/sons/porta-1.3192b310.webm", mp3: "/sons/porta-1.a619c5f0.mp3", frames: 54322, onset: 3585 },
    { webm: "/sons/porta-2.fe50dcdd.webm", mp3: "/sons/porta-2.e7fd2403.mp3", frames: 49120, onset: 10533 },
  ],
  "porta-fecha": [
    { webm: "/sons/porta-fecha-1.669085ad.webm", mp3: "/sons/porta-fecha-1.b2e2c17e.mp3", frames: 27133, onset: 870 },
    { webm: "/sons/porta-fecha-2.2be3736d.webm", mp3: "/sons/porta-fecha-2.b645385a.mp3", frames: 42143, onset: 3761 },
  ],
  "acender": [
    { webm: "/sons/acender-1.5d683e07.webm", mp3: "/sons/acender-1.3630951d.mp3", frames: 57600, onset: 3667 },
    { webm: "/sons/acender-2.06480ffe.webm", mp3: "/sons/acender-2.9b57c2bf.mp3", frames: 27601, onset: 2398 },
  ],
  "fogo": [
    { webm: "/sons/fogo-1.ebadfeee.webm", mp3: "/sons/fogo-1.e1ebce28.mp3", frames: 408000, onset: 18206, loopStart: 0.25, loopEnd: 8.25 },
  ],
} as const satisfies Record<string, readonly SampleFile[]>;

export type SampleSetId = keyof typeof SAMPLE_SETS;

export interface SampleSound {
  readonly set: SampleSetId;
  /** Ganho linear, velocidade (tom) e passa-baixa (Hz) na hora de tocar. */
  readonly gain: number;
  readonly rate: number;
  readonly lowpass?: number;
  readonly loop?: boolean;
}

/** O conjunto que cada som toca; os outros continuam sintetizados. */
export const SAMPLE_SOUNDS: Readonly<Partial<Record<SoundId, SampleSound>>> = {
  "passo-terra": { set: "passo-terra", gain: 1, rate: 1 },
  "passo-pedra": { set: "passo-pedra", gain: 1, rate: 1 },
  "passo-madeira": { set: "passo-madeira", gain: 1, rate: 1 },
  "passo-agua": { set: "passo-agua", gain: 1, rate: 1 },
  "machado-madeira": { set: "machado-madeira", gain: 1, rate: 1 },
  "picareta": { set: "picareta", gain: 1, rate: 1 },
  "golpe-ar": { set: "golpe-ar", gain: 1, rate: 1 },
  "acerto": { set: "acerto", gain: 1, rate: 1 },
  "flecha-solta": { set: "flecha-solta", gain: 1, rate: 1 },
  "flecha-crava": { set: "flecha-crava", gain: 1, rate: 1 },
  "bau": { set: "bau", gain: 1, rate: 1 },
  "bau-fecha": { set: "bau-fecha", gain: 1, rate: 1 },
  "porta": { set: "porta", gain: 1, rate: 1 },
  "porta-fecha": { set: "porta-fecha", gain: 1, rate: 1 },
  "acender": { set: "acender", gain: 1, rate: 1 },
  "fogo": { set: "fogo", gain: 1, rate: 1, loop: true },
  "passo-grama": { set: "passo-terra", gain: 0.8913, rate: 1.06, lowpass: 5000 },
  "passo-areia": { set: "passo-terra", gain: 1, rate: 1.15 },
  "passo-lama": { set: "passo-terra", gain: 1.2589, rate: 0.8, lowpass: 1400 },
};

/** Leito de ambiente (F46): loop longo, carregado sob demanda pelo `AmbienceBank`. */
export interface AmbienceBedFile {
  /** Opus em WebM (principal) e MP3 (reserva) em public/, com o hash do conteúdo no nome. */
  readonly webm: string;
  readonly mp3: string;
  readonly channels: number;
  /** Amostras a 48000 Hz, com o enchimento (o banco decodifica em outra taxa: valem os pontos de loop). */
  readonly frames: number;
  /** O trecho que repete, em segundos; antes e depois dele, o enchimento circular. */
  readonly loopStart: number;
  readonly loopEnd: number;
  /** Ganho linear na hora de tocar. */
  readonly gain: number;
}

/** Os leitos de ambiente. */
export const AMBIENCE_BEDS = {
  "floresta-dia": { webm: "/sons/leito-floresta-dia.1762eaaf.webm", mp3: "/sons/leito-floresta-dia.ac30ff03.mp3", channels: 2, frames: 1464000, loopStart: 0.25, loopEnd: 30.25, gain: 1 },
  "floresta-noite": { webm: "/sons/leito-floresta-noite.a3ca925f.webm", mp3: "/sons/leito-floresta-noite.0975863e.mp3", channels: 2, frames: 1464000, loopStart: 0.25, loopEnd: 30.25, gain: 1 },
  "praia": { webm: "/sons/leito-praia.aadc5ff9.webm", mp3: "/sons/leito-praia.f41ef459.mp3", channels: 2, frames: 1464000, loopStart: 0.25, loopEnd: 30.25, gain: 1 },
  "mar": { webm: "/sons/leito-mar.f78d8ad1.webm", mp3: "/sons/leito-mar.787da6d4.mp3", channels: 2, frames: 1464000, loopStart: 0.25, loopEnd: 30.25, gain: 1 },
  "mar-tempestade": { webm: "/sons/leito-mar-tempestade.7c0c3ea3.webm", mp3: "/sons/leito-mar-tempestade.eeeafa56.mp3", channels: 2, frames: 1464000, loopStart: 0.25, loopEnd: 30.25, gain: 1 },
} as const satisfies Record<BedId, AmbienceBedFile>;

/** Faixa de música gravada (F84): estéreo, inteira, tocada em streaming. */
export interface MusicTrackFile {
  /** Só MP3 (o WebKit entrega zeros do WebM ao Web Audio), em public/, com o hash do conteúdo no nome. */
  readonly mp3: string;
  /** Duração da faixa tratada (s). */
  readonly seconds: number;
  /** Ganho linear na hora de tocar (o volume já vem no arquivo: 1). */
  readonly gain: number;
}

/** As faixas de música. */
export const MUSIC_TRACKS = {
  "tema": { mp3: "/sons/musica-tema.b8a23d92.mp3", seconds: 192.365167, gain: 1 },
  "herois": { mp3: "/sons/musica-herois.79046921.mp3", seconds: 199.587646, gain: 1 },
  "exploracao": { mp3: "/sons/musica-exploracao.81445fbf.mp3", seconds: 213.419979, gain: 1 },
  "combate": { mp3: "/sons/musica-combate.82386856.mp3", seconds: 169.106271, gain: 1 },
  "chefe": { mp3: "/sons/musica-chefe.c2d0405b.mp3", seconds: 171.1155, gain: 1 },
} as const satisfies Record<TrackId, MusicTrackFile>;
